/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Evidenceinlineor2Inputs */

const en_evidenceinlineor2 = /** @type {(inputs: Evidenceinlineor2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`or`)
};

const pt_evidenceinlineor2 = /** @type {(inputs: Evidenceinlineor2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ou`)
};

/**
* | output |
* | --- |
* | "or" |
*
* @param {Evidenceinlineor2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const evidenceinlineor2 = /** @type {((inputs?: Evidenceinlineor2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Evidenceinlineor2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_evidenceinlineor2(inputs)
	return pt_evidenceinlineor2(inputs)
});
export { evidenceinlineor2 as "evidenceInlineOr" }